/**
 * The major version is chosen by development, by hand, when something breaks
 * with what came before. The build number and the commit come from CI.
 */
export const APP_MAJOR = 1;
/** The one place that decides what a missing build or commit reads as. */
export function resolveVersion(build, commit) {
    return { major: APP_MAJOR, build: String(build || 'dev'), commit: String(commit || 'local').slice(0, 7) };
}
/** `1.142 · a3f9c21`: what the footer shows, and what a bug report quotes. */
export function formatVersion(version) {
    return `${version.major}.${version.build} · ${version.commit}`;
}
